export const DRUG_SCREEN_STATUS = {
	NOT_STARTED: 0,
	INITIATED: 1,
	COMPLETED: 2
};